import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export interface InstagramSearchStorageState {
  layout: "grid" | "flat";
  setLayout: (layout: "grid" | "flat") => void;

  asideFormExpanded: boolean;
  setAsideFormExpanded: (asideFormExpanded: boolean) => void;

  asideListsExpanded: boolean;
  setAsideListsExpanded: (asideListsExpanded: boolean) => void;

  asideListsAllVisibleExpanded: boolean;
  setAsideListsAllVisibleExpanded: (
    asideListsAllVisibleExpanded: boolean,
  ) => void;
}

export const useInstagramSearchStorage = create<InstagramSearchStorageState>()(
  persist(
    (set) => ({
      layout: "grid",
      setLayout: (layout) => set({ layout }),

      asideFormExpanded: false,
      setAsideFormExpanded: (asideFormExpanded) => set({ asideFormExpanded }),

      asideListsExpanded: true,
      setAsideListsExpanded: (asideListsExpanded) =>
        set({ asideListsExpanded }),

      asideListsAllVisibleExpanded: true,
      setAsideListsAllVisibleExpanded: (asideListsAllVisibleExpanded) =>
        set({ asideListsAllVisibleExpanded }),
    }),
    {
      name: "instagram-search-store",
      version: 1,
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
